import React from 'react';

function Blogs() {
  return (
    <section className="blog-main section-padding">
      <div className="container">
        <div className="row lg-marg justify-content-around">
          <div className="col-lg-7">
            <div className="md-mb80">
              <div className="item mb-50">
                <div className="img">
                  <img src="/light/assets/imgs/blog/blog1.jpg" alt="" />
                </div>
                <div className="content main-bg">
                  <div className="d-flex align-items-center mb-15">
                    <div className="post-date">20 July 2020</div>
                    <div className="commt opacity-7 fz-13">
                      <span className="ti-comment-alt mr-10"></span>4 Comments
                    </div>
                  </div>
                  <h4 className="mb-15">
                    <a href="/light/blog-details">
                      12 Tips to Leading an Extraordinary Company
                    </a>
                  </h4>
                  <p>
                    So striking at of to welcomed resolved. Northward by
                    described up household therefore attention.
                  </p>
                  <a href="#0" className="d-flex align-items-center mt-40">
                    <span className="text mr-15">Read More</span>
                    <span className="ti-arrow-top-right"></span>
                  </a>
                </div>
              </div>
              <div className="item mb-50">
                <div className="img">
                  <img src="/light/assets/imgs/blog/blog2.jpg" alt="" />
                </div>
                <div className="content main-bg">
                  <div className="d-flex align-items-center mb-15">
                    <div className="post-date">20 July 2020</div>
                    <div className="commt opacity-7 fz-13">
                      <span className="ti-comment-alt mr-10"></span>4 Comments
                    </div>
                  </div>
                  <h4 className="mb-15">
                    <a href="/light/blog-details">
                      12 Tips to Leading an Extraordinary Company
                    </a>
                  </h4>
                  <p>
                    So striking at of to welcomed resolved. Northward by
                    described up household therefore attention.
                  </p>
                  <a href="#0" className="d-flex align-items-center mt-40">
                    <span className="text mr-15">Read More</span>
                    <span className="ti-arrow-top-right"></span>
                  </a>
                </div>
              </div>
              <div className="item">
                <div className="img">
                  <img src="/light/assets/imgs/blog/blog4.jpg" alt="" />
                </div>
                <div className="content main-bg">
                  <div className="d-flex align-items-center mb-15">
                    <div className="post-date">20 July 2020</div>
                    <div className="commt opacity-7 fz-13">
                      <span className="ti-comment-alt mr-10"></span>4 Comments
                    </div>
                  </div>
                  <h4 className="mb-15">
                    <a href="/light/blog-details">
                      12 Tips to Leading an Extraordinary Company
                    </a>
                  </h4>
                  <p>
                    So striking at of to welcomed resolved. Northward by
                    described up household therefore attention.
                  </p>
                  <a href="#0" className="d-flex align-items-center mt-40">
                    <span className="text mr-15">Read More</span>
                    <span className="ti-arrow-top-right"></span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="sidebar">
              <div className="search-box">
                <input type="text" name="search-post" placeholder="Search" />
                <span className="icon pe-7s-search"></span>
              </div>
              <div className="widget catogry">
                <h6 className="title-widget">Categories</h6>
                <ul className="rest">
                  <li>
                    <span>
                      <a href="/light/blog-list">Business</a>
                    </span>
                    <span className="ml-auto">33</span>
                  </li>
                  <li>
                    <span>
                      <a href="/light/blog-list">Lifestyle</a>
                    </span>
                    <span className="ml-auto">05</span>
                  </li>
                  <li>
                    <span>
                      <a href="/light/blog-list">Creative</a>
                    </span>
                    <span className="ml-auto">28</span>
                  </li>
                  <li>
                    <span>
                      <a href="/light/blog-list">WordPress</a>
                    </span>
                    <span className="ml-auto">17</span>
                  </li>
                  <li>
                    <span>
                      <a href="/light/blog-list">Design</a>
                    </span>
                    <span className="ml-auto">45</span>
                  </li>
                </ul>
              </div>
              <div className="widget last-post-thum">
                <h6 className="title-widget">latest Posts</h6>
                <div className="item d-flex align-items-center">
                  <div>
                    <div className="img">
                      <a href="/light/blog-list">
                        <img src="/light/assets/imgs/blog/c1.jpg" alt="" />
                        <span className="date">
                          <span>
                            14 / <br /> sep
                          </span>
                        </span>
                      </a>
                    </div>
                  </div>
                  <div className="cont">
                    <span className="tag">
                      <a href="/light/blog-list">Web Design</a>
                    </span>
                    <h6>
                      <a href="/light/blog-list">
                        ways to quickly increase traffic to your website
                      </a>
                    </h6>
                  </div>
                </div>
                <div className="item d-flex align-items-center">
                  <div>
                    <div className="img">
                      <a href="/light/blog-list">
                        <img src="/light/assets/imgs/blog/c2.jpg" alt="" />
                        <span className="date">
                          <span>
                            14 / <br /> sep
                          </span>
                        </span>
                      </a>
                    </div>
                  </div>
                  <div className="cont">
                    <span className="tag">
                      <a href="/light/blog-list">Web Design</a>
                    </span>
                    <h6>
                      <a href="/light/blog-list">
                        breaking the rules: using sqlite to demo web
                      </a>
                    </h6>
                  </div>
                </div>
                <div className="item d-flex align-items-center">
                  <div>
                    <div className="img">
                      <a href="/light/blog-list">
                        <img src="/light/assets/imgs/blog/c3.jpg" alt="" />
                        <span className="date">
                          <span>
                            14 / <br /> sep
                          </span>
                        </span>
                      </a>
                    </div>
                  </div>
                  <div className="cont">
                    <span className="tag">
                      <a href="/light/blog-list">Web Design</a>
                    </span>
                    <h6>
                      <a href="/light/blog-list">
                        building better ui designs with layout grids
                      </a>
                    </h6>
                  </div>
                </div>
              </div>
              <div className="widget tags">
                <h6 className="title-widget">Tags</h6>
                <div>
                  <a href="/light/blog-list">Creative</a>
                  <a href="/light/blog-list">Design</a>
                  <a href="/light/blog-list">Dark & Light</a>
                  <a href="/light/blog-list">Minimal</a>
                  <a href="/light/blog-list">Infolio</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Blogs;
